import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { SingleSelect, } from 'react-select-material-ui';
import { theme } from '../../themes/theme';
const DetailsSelect = (props) => (_jsx("div", { children: _jsx(SingleSelect, { style: {
            textTransform: 'capitalize',
        }, size: "small", margin: "none", label: props.label, name: props.name, onChange: (value, option) => {
            props.onChange(value, option);
        }, options: props.options, value: props.value, InputLabelProps: {
            style: {
                fontWeight: 'bold',
                fontFamily: 'Roboto Condensed',
            },
        }, SelectProps: {
            name: props.name,
            isClearable: true,
            isSearchable: true,
            menuPlacement: 'auto',
            styles: {
                menu: (provided) => (Object.assign(Object.assign({}, provided), { width: 'auto', minWidth: '100%' })),
                control: (_, state) => ({
                    borderBottom: state.isDisabled
                        ? `1px solid ${theme.palette.grey[400]}`
                        : `1px solid ${theme.palette.grey[600]}`,
                }),
                menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
                valueContainer: () => ({
                    paddingTop: '12px',
                }),
                singleValue: (provided) => (Object.assign(Object.assign({}, provided), { top: '65%', marginLeft: 0, border: 0 })),
            },
            menuPortalTarget: document.body,
        } }) }));
export default memo(DetailsSelect);
